import * as fromDatatype from '../datatype-library';

export interface bl_fi_mst_search_filter_section_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  search_filter_set_guid: fromDatatype.GuidDataFieldInterface;
  rating_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_hdr_guid: fromDatatype.GuidDataFieldInterface;
  point_currency_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  sort_order: fromDatatype.VarcharDatatypeInterface;
  selected_value: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_search_filter_section_RowClass implements bl_fi_mst_search_filter_section_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  search_filter_set_guid: fromDatatype.GuidDataFieldInterface;
  rating_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_hdr_guid: fromDatatype.GuidDataFieldInterface;
  point_currency_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  sort_order: fromDatatype.VarcharDatatypeInterface;
  selected_value: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
